import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { createSafeContext } from "@coveord/plasma-mantine";
var ref = _sliced_to_array(createSafeContext("EmptyState component was not found in tree"), 2);
export var EmptyStateProvider = ref[0], useEmptyStateContext = ref[1];

//# sourceMappingURL=EmptyStateContext.js.map